<template>
    <page title="rejectRoleRequestTitle">
        <template #pageContainer>
            <form>
                <v-textarea
                    :disabled="loading"
                    clearable
                    clear-icon="cancel"
                    :label="$t('text.rejectRoleReason')"
                    required
                    :error-messages="reasonErrors"
                    v-model="reason">
                </v-textarea>

                <v-btn
                    class="mr-4"
                    :disabled="$v.$invalid || loading"
                    @click="reject">
                    {{ $t(`text.rejectButton`) }}
                </v-btn>

                <v-btn
                    :disabled="loading"
                    class="mr-4"
                    @click="back">
                    {{ $t(`text.backButton`) }}
                </v-btn>
            </form>

            <spinner :loading="loading"></spinner>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';

import roleRequestActions from '../store/actions/roleRequest';
import namespace from '../store/namespace';
import Page from '../general/Page.vue';
import Spinner from '../general/Spinner.vue';

import modelState from '../mixins/modelState';

export default {
	name: 'RejectRoleRequest',
	mixins: [modelState],
	components: {
		Page,
		Spinner,
	},
	validations: {
		reason: {
			required,
		},
	},
	data() {
		return {
			roleId: this.$route.params.roleId,
			userId: this.$route.params.userId,
			organizationId: this.$route.params.organizationId,
			reason: '',
			loading: false,
		};
	},
	computed: {
		...mapGetters(namespace.ROLEREQUEST, ['Links', 'Entities']),
		reasonErrors() {
			const errors = [];

			if (!this.$v.reason.$dirty) return errors;

			const apiErrors = this.validateProperty('Reason');

			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			!this.$v.reason.required && errors.push(this.$i18n.t('text.errorReasonRequired'));

			return errors;
		},
	},
	methods: {
		...mapActions(namespace.ROLEREQUEST, [roleRequestActions.UPDATE_ROLE_REQUEST]),
		async reject() {
			this.loading = true;
			this.$v.$touch();

			if (!this.$v.$invalid) {
				const roleRequest = this.Entities.find(request => request.roleId === this.roleId
                    && request.userId === this.userId
                    && request.organizationId === this.organizationId);

				const link = roleRequest.links.find(x => x.rel === 'update');

				if (roleRequest && link) {
					const item = {
						status: 1,
						reason: this.reason,
						link,
					};

					try {
						this.modelState = {};
						await this.UPDATE_ROLE_REQUEST(item);

						this.back();
					} catch (e) {
						if (e.response.status === 422) {
							this.modelState = e.response.data;
							if (this.modelError()) {
								throw new Error(this.modelError());
							}
						}

						throw e;
					} finally {
						this.loading = false;
					}
				}
			}

			this.loading = false;
		},
		back() {
			this.$router.go(-1);
		},
	},
};
</script>
